import React from "react";
import HighlightIcon from "@mui/icons-material/Highlight";

export default function Header() {
  return (
    <header className="Header">
      <h1>
        <HighlightIcon /> {""} Keeper App
      </h1>
    </header>
  );
}
